import { is } from 'ramda'

export const CONTACTS_ACCESS_DECLINED = 'Contacts Access Declined'

export default function () {
  return this.sendEventWithCallback('contacts.list', {})
    .then(data => {
      // shortcut
      if (is(Object, data.contacts)) {
        return data
      }

      return Promise.reject(new Error(
        (data.contacts === false)
          ? CONTACTS_ACCESS_DECLINED
          : this.ERROR_UNKNOWN
      ))
    })
}
